export const GET_NEWS_REQUEST = 'GET_NEWS_REQUEST';
export const GET_NEWS_DATA = 'GET_NEWS_DATA';
export const GET_NEWS_ERROR = 'GET_NEWS_ERROR';
